import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig, whitelistedProductIds } from "./config"

import "./styles/index.css"

const isMobile = window.innerWidth <= 768;
const inputCssSelector = isMobile ? "#boost-pfs-search-box-mobile" : "#boost-pfs-search-box-desktop";


init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: inputCssSelector,
    contentCssSelector: "#MainContent",
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/',

    // Uncomment to redirect to search page instead of rewriting browser history
    // serpPathRedirect: true,
    
    serpQuery: {
        products: {
            // fields: [
            //     "productId",
            //     "url",
            //     "name",
            //     "imageUrl",
            //     "thumbUrl",
            //     "description",
            //     "brand",
            //     "availability",
            //     "price",
            //     "priceText",
            //     "listPrice",
            //     "ratingValue",
            //     "reviewCount"
            //     // 'customFields.key', 'customFields.value'
            // ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0,
            filter: [{
                any: [
                    {
                        field: "availability",
                        value: ["InStock"]
                    },
                    {
                        field: "productId",
                        value: whitelistedProductIds
                    }
                ]
            }]
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "thumbUrl",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount"
            ],
            size: defaultConfig.autocompleteProductsSize,
            filter: [{
                any: [
                    {
                        field: "availability",
                        value: ["InStock"]
                    },
                    {
                        field: "productId",
                        value: whitelistedProductIds
                    }
                ]
            }]
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
     //fallback: true,
    persistentSearchCache: true,
    // // Uncomment for Category Merchandising
    categoryCssSelector: '#CollectionAjaxContent',
       categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                filter: [{
                    any: [
                        {
                            field: "availability",
                            value: ["InStock"]
                        },
                        {
                            field: "productId",
                            value: whitelistedProductIds
                        }
                    ]
                }]
            }
        }
    },
}).then(() => {
    console.log("Nosto Search initialized")
})
